import styled, { css } from 'styled-components';

const StyledContainer = styled.div<{ $active?: boolean }>`
	position: relative;

	&:hover {
		img {
			filter: invert(1);
			opacity: 1;
		}
	}

	img {
		position: absolute;
		right: 15px;
		top: 50%;
		transform: translateY(-50%);
		width: 14px;
		height: 14px;
		opacity: 0.25;
		user-select: none;
		pointer-events: none;
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}

	${({ $active }) =>
		$active &&
		css`
			input {
				background-color: #2d70da;
				color: #ffffff;
			}

			img {
				opacity: 1;
			}
		`}
`;

export { StyledContainer };
